import Flags from "./Flags/index";
import { CheckSvgUri, parseSvgUri, YodiwoSVGProps } from './SvgIconsSelector';
// ------------------------------------------------------------------------------------------------
export function GetSVGUrl(uri: string) {
    if (!CheckSvgUri(uri))
        return null;

    let parse = parseSvgUri(uri);
    if (parse == null)
        return null;

    // TODO: support multiple packages
    return Flags[parse.name];
}
// ------------------------------------------------------------------------------------------------
export default function YodiwoSVGBase(props: YodiwoSVGProps) {
    let url = GetSVGUrl(props.uri);
    if (url == null)
        return null;
    return <img src={url} width={props.width} height={props.height} />
}
// ------------------------------------------------------------------------------------------------
